import { Action } from '@ngrx/store';
import {
  ClaimRequest,
  CreateClaimForm,
  Claim,
  ClaimLine,
  ClaimRequestForm
} from '@ecosure-suite/shared/util-entities';
import { Pagination } from '@ecosure-suite/shared/utils-helpers';

export enum ClaimRequestsActionTypes {
  GET_CLAIM_REQUEST = '[ClaimRequests] Get Claim Request',
  GET_CLAIM_REQUEST_SUCCESS = '[ClaimRequests] Get Claim Request Success',
  GET_CLAIM_REQUEST_FAIL = '[ClaimRequests] Get Claim Request Fail',
  CREATE_CLAIM_REQUEST = '[ClaimRequests] Create Claim Request',
  CREATE_CLAIM_REQUEST_SUCCESS = '[ClaimRequests] Create Claim Request Success',
  CREATE_CLAIM_REQUEST_FAIL = '[ClaimRequests] Create Claim Request Fail',
  EDIT_CLAIM_REQUEST = '[ClaimRequests] Edit Claim Request',
  EDIT_CLAIM_REQUEST_SUCCESS = '[ClaimRequests] Edit Claim Request Success',
  EDIT_CLAIM_REQUEST_FAIL = '[ClaimRequests] Edit Claim Request Fail',
  SEARCH_CLAIM_REQUESTS_BY_ID_NUMBER = '[ClaimRequests] Search Claim Requests By Id Number',
  SEARCH_CLAIM_REQUESTS_BY_ID_NUMBER_SUCCESS = '[ClaimRequests] Search Claim Requests By Id Number Success',
  SEARCH_CLAIM_REQUESTS_BY_ID_NUMBER_FAIL = '[ClaimRequests] Search Claim Requests By Id Number Fail',
  LIST_CLAIM_REQUESTS_BY_ID_NUMBER = '[ClaimRequests] List Claim Requests By Id Number',
  LIST_CLAIM_REQUESTS_BY_ID_NUMBER_SUCCESS = '[ClaimRequests] List Claim Requests By Id Number Success',
  LIST_CLAIM_REQUESTS_BY_ID_NUMBER_FAIL = '[ClaimRequests] List Claim Requests By Id Number Fail',
  LIST_CLAIM_REQUESTS_BY_STATUS = '[ClaimRequests] List Claim Requests By Status',
  LIST_CLAIM_REQUESTS_BY_STATUS_SUCCESS = '[ClaimRequests] List Claim Requests By Status Success',
  LIST_CLAIM_REQUESTS_BY_STATUS_FAIL = '[ClaimRequests] List Claim Requests By Status Fail',
  LIST_SUPERVISOR_CLAIM_REQUESTS_BY_STATUS = '[ClaimRequests] List Supervisor Claim Requests By Status',
  LIST_SUPERVISOR_CLAIM_REQUESTS_BY_STATUS_SUCCESS = '[ClaimRequests] List Supervisor Claim Requests By Status Success',
  LIST_SUPERVISOR_CLAIM_REQUESTS_BY_STATUS_FAIL = '[ClaimRequests] List Supervisor Claim Requests By Status Fail',
  LIST_CLAIM_REQUESTS_BY_ASSIGNEE = '[ClaimRequests] List Claim Requests By Assignee',
  LIST_CLAIM_REQUESTS_BY_ASSIGNEE_SUCCESS = '[ClaimRequests] List Claim Requests By Assignee Success',
  LIST_CLAIM_REQUESTS_BY_ASSIGNEE_FAIL = '[ClaimRequests] List Claim Requests By Assignee Fail',
  LIST_CLAIM_REQUESTS_BY_CURRENT_USER = '[ClaimRequests] List Claim Requests By Current User',
  LIST_CLAIM_REQUESTS_BY_CURRENT_USER_SUCCESS = '[ClaimRequests] List Claim Requests By Current User Success',
  LIST_CLAIM_REQUESTS_BY_CURRENT_USER_FAIL = '[ClaimRequests] List Claim Requests By Current User Fail',
  ASSIGN_CLAIM_REQUEST_TO_VERIFIER = '[ClaimRequests] Assign Claim Request To Verifier',
  ASSIGN_CLAIM_REQUEST_TO_VERIFIER_SUCCESS = '[ClaimRequests] Assign Claim Request To Verifier Success',
  ASSIGN_CLAIM_REQUEST_TO_VERIFIER_FAIL = '[ClaimRequests] Assign Claim Request To Verifier Fail',
  SELECT_REQUEST_REQUEST = '[ClaimRequests] Select Claim Request',
  CLEAR_REQUEST_REQUEST = '[ClaimRequests] Clear Claim Request'
}

export class GetClaimRequest implements Action {
  readonly type = ClaimRequestsActionTypes.GET_CLAIM_REQUEST;
  constructor(public payload: number) {}
}

export class GetClaimRequestSuccess implements Action {
  readonly type = ClaimRequestsActionTypes.GET_CLAIM_REQUEST_SUCCESS;
  constructor(public payload: ClaimRequest) {}
}

export class GetClaimRequestFail implements Action {
  readonly type = ClaimRequestsActionTypes.GET_CLAIM_REQUEST_FAIL;
  constructor(public payload: Error) {}
}

export class CreateClaimRequest implements Action {
  readonly type = ClaimRequestsActionTypes.CREATE_CLAIM_REQUEST;
  constructor(public payload: Partial<CreateClaimForm>) {}
}

export class CreateClaimRequestSuccess implements Action {
  readonly type = ClaimRequestsActionTypes.CREATE_CLAIM_REQUEST_SUCCESS;
  constructor(
    public payload: {
      claimRequest: ClaimRequest;
      claim: Claim;
      claimLine: ClaimLine;
    }
  ) {}
}

export class CreateClaimRequestFail implements Action {
  readonly type = ClaimRequestsActionTypes.CREATE_CLAIM_REQUEST_FAIL;
  constructor(public payload: Error) {}
}

export class EditClaimRequest implements Action {
  readonly type = ClaimRequestsActionTypes.EDIT_CLAIM_REQUEST;
  constructor(public payload: ClaimRequestForm) {}
}

export class EditClaimRequestSuccess implements Action {
  readonly type = ClaimRequestsActionTypes.EDIT_CLAIM_REQUEST_SUCCESS;
  constructor(public payload: ClaimRequest) {}
}

export class EditClaimRequestFail implements Action {
  readonly type = ClaimRequestsActionTypes.EDIT_CLAIM_REQUEST_FAIL;
  constructor(public payload: Error) {}
}

export class AssignClaimRequestToVerifier implements Action {
  readonly type = ClaimRequestsActionTypes.ASSIGN_CLAIM_REQUEST_TO_VERIFIER;
  constructor(public payload: { claimRequestId: number; username: string }) {}
}

export class AssignClaimRequestToVerifierSuccess implements Action {
  readonly type =
    ClaimRequestsActionTypes.ASSIGN_CLAIM_REQUEST_TO_VERIFIER_SUCCESS;
  constructor(public payload: ClaimRequest) {}
}

export class AssignClaimRequestToVerifierFail implements Action {
  readonly type =
    ClaimRequestsActionTypes.ASSIGN_CLAIM_REQUEST_TO_VERIFIER_FAIL;
  constructor(public payload: Error) {}
}

export class ListClaimRequestByStatus implements Action {
  readonly type = ClaimRequestsActionTypes.LIST_CLAIM_REQUESTS_BY_STATUS;
  constructor(public payload: { status: string; page: Pagination }) {}
}

export class ListClaimRequestByStatusSuccess implements Action {
  readonly type =
    ClaimRequestsActionTypes.LIST_CLAIM_REQUESTS_BY_STATUS_SUCCESS;
  constructor(
    public payload: {
      claimRequests: ClaimRequest[];
      page: Partial<Pagination>;
    }
  ) {}
}

export class ListClaimRequestByStatusFail implements Action {
  readonly type = ClaimRequestsActionTypes.LIST_CLAIM_REQUESTS_BY_STATUS_FAIL;
  constructor(public payload: Error) {}
}

export class ListSupervisorClaimRequestByStatus implements Action {
  readonly type =
    ClaimRequestsActionTypes.LIST_SUPERVISOR_CLAIM_REQUESTS_BY_STATUS;
  constructor(public payload: { status: string; page: Pagination }) {}
}

export class ListSupervisorClaimRequestByStatusSuccess implements Action {
  readonly type =
    ClaimRequestsActionTypes.LIST_SUPERVISOR_CLAIM_REQUESTS_BY_STATUS_SUCCESS;
  constructor(
    public payload: {
      claimRequests: ClaimRequest[];
      page: Partial<Pagination>;
    }
  ) {}
}

export class ListSupervisorClaimRequestByStatusFail implements Action {
  readonly type =
    ClaimRequestsActionTypes.LIST_SUPERVISOR_CLAIM_REQUESTS_BY_STATUS_FAIL;
  constructor(public payload: Error) {}
}

export class ListClaimRequestByAssingee implements Action {
  readonly type = ClaimRequestsActionTypes.LIST_CLAIM_REQUESTS_BY_ASSIGNEE;
  constructor(public payload: { username: string; page: Pagination }) {}
}

export class ListClaimRequestByAssingeeSuccess implements Action {
  readonly type =
    ClaimRequestsActionTypes.LIST_CLAIM_REQUESTS_BY_ASSIGNEE_SUCCESS;
  constructor(
    public payload: {
      claimRequests: ClaimRequest[];
      page: Partial<Pagination>;
    }
  ) {}
}

export class ListClaimRequestByAssingeeFail implements Action {
  readonly type = ClaimRequestsActionTypes.LIST_CLAIM_REQUESTS_BY_ASSIGNEE_FAIL;
  constructor(public payload: Error) {}
}

export class ListClaimRequestByCurrentUser implements Action {
  readonly type = ClaimRequestsActionTypes.LIST_CLAIM_REQUESTS_BY_CURRENT_USER;
  constructor(public payload: Pagination) {}
}

export class ListClaimRequestByCurrentUserSuccess implements Action {
  readonly type =
    ClaimRequestsActionTypes.LIST_CLAIM_REQUESTS_BY_CURRENT_USER_SUCCESS;
  constructor(
    public payload: {
      claimRequests: ClaimRequest[];
      page: Partial<Pagination>;
    }
  ) {}
}

export class ListClaimRequestByCurrentUserFail implements Action {
  readonly type =
    ClaimRequestsActionTypes.LIST_CLAIM_REQUESTS_BY_CURRENT_USER_FAIL;
  constructor(public payload: Error) {}
}

export class ListClaimRequestByIdNumber implements Action {
  readonly type = ClaimRequestsActionTypes.LIST_CLAIM_REQUESTS_BY_ID_NUMBER;
  constructor(public payload: { idNumber: string; page: Pagination }) {}
}

export class ListClaimRequestByIdNumberSuccess implements Action {
  readonly type =
    ClaimRequestsActionTypes.LIST_CLAIM_REQUESTS_BY_ID_NUMBER_SUCCESS;
  constructor(
    public payload: { claimRequests: ClaimRequest[]; page: Partial<Pagination> }
  ) {}
}

export class ListClaimRequestByIdNumberFail implements Action {
  readonly type =
    ClaimRequestsActionTypes.LIST_CLAIM_REQUESTS_BY_ID_NUMBER_FAIL;
  constructor(public payload: Error) {}
}

export class SearchClaimRequestByIdNumber implements Action {
  readonly type = ClaimRequestsActionTypes.SEARCH_CLAIM_REQUESTS_BY_ID_NUMBER;
  constructor(public payload: { idNumber: string; page: Pagination }) {}
}

export class SearchClaimRequestByIdNumberSuccess implements Action {
  readonly type =
    ClaimRequestsActionTypes.SEARCH_CLAIM_REQUESTS_BY_ID_NUMBER_SUCCESS;
  constructor(
    public payload: {
      claimRequests: ClaimRequest[];
      claims: Claim[];
      claimLines: ClaimLine[];
      page: Partial<Pagination>;
    }
  ) {}
}

export class SearchClaimRequestByIdNumberFail implements Action {
  readonly type =
    ClaimRequestsActionTypes.SEARCH_CLAIM_REQUESTS_BY_ID_NUMBER_FAIL;
  constructor(public payload: Error) {}
}

export class SelectClaimRequest implements Action {
  readonly type = ClaimRequestsActionTypes.SELECT_REQUEST_REQUEST;
  constructor(public payload: number) {}
}

export class ClearClaimRequest implements Action {
  readonly type = ClaimRequestsActionTypes.CLEAR_REQUEST_REQUEST;
}

export type ClaimRequestsAction =
  | GetClaimRequest
  | GetClaimRequestSuccess
  | GetClaimRequestFail
  | CreateClaimRequest
  | CreateClaimRequestSuccess
  | CreateClaimRequestFail
  | EditClaimRequest
  | EditClaimRequestSuccess
  | EditClaimRequestFail
  | AssignClaimRequestToVerifier
  | AssignClaimRequestToVerifierSuccess
  | AssignClaimRequestToVerifierFail
  | ListClaimRequestByStatus
  | ListClaimRequestByStatusSuccess
  | ListClaimRequestByStatusFail
  | ListClaimRequestByAssingee
  | ListClaimRequestByAssingeeSuccess
  | ListClaimRequestByAssingeeFail
  | ListClaimRequestByCurrentUser
  | ListClaimRequestByCurrentUserSuccess
  | ListClaimRequestByCurrentUserFail
  | ListClaimRequestByIdNumber
  | ListClaimRequestByIdNumberSuccess
  | ListClaimRequestByIdNumberFail
  | ListSupervisorClaimRequestByStatus
  | ListSupervisorClaimRequestByStatusSuccess
  | ListSupervisorClaimRequestByStatusFail
  | SearchClaimRequestByIdNumber
  | SearchClaimRequestByIdNumberSuccess
  | SearchClaimRequestByIdNumberFail
  | SelectClaimRequest
  | ClearClaimRequest;

export const fromClaimRequestsActions = {
  GetClaimRequest,
  GetClaimRequestSuccess,
  GetClaimRequestFail,
  CreateClaimRequest,
  CreateClaimRequestSuccess,
  CreateClaimRequestFail,
  EditClaimRequest,
  EditClaimRequestSuccess,
  EditClaimRequestFail,
  AssignClaimRequestToVerifier,
  AssignClaimRequestToVerifierSuccess,
  AssignClaimRequestToVerifierFail,
  ListClaimRequestByStatus,
  ListClaimRequestByStatusSuccess,
  ListClaimRequestByStatusFail,
  ListClaimRequestByAssingee,
  ListClaimRequestByAssingeeSuccess,
  ListClaimRequestByAssingeeFail,
  ListClaimRequestByCurrentUser,
  ListClaimRequestByCurrentUserSuccess,
  ListClaimRequestByCurrentUserFail,
  ListClaimRequestByIdNumber,
  ListClaimRequestByIdNumberSuccess,
  ListClaimRequestByIdNumberFail,
  ListSupervisorClaimRequestByStatus,
  ListSupervisorClaimRequestByStatusSuccess,
  ListSupervisorClaimRequestByStatusFail,
  SearchClaimRequestByIdNumber,
  SearchClaimRequestByIdNumberSuccess,
  SearchClaimRequestByIdNumberFail,
  SelectClaimRequest,
  ClearClaimRequest
};
